import React from 'react';
import PropTypes from 'prop-types';
import MainQuestionPrint from './MainQuestionPrint';
import ContextQuestionPrint from './ContextQuestionPrint';

const styling = {
  margin: '0 auto',
  background: 'white',
  position: 'relative',
  padding: '1em',
  breakAfter: 'page',
};

const SectionSurveyPrint = ({
  section, trialName, sectionIndex, answers,
}) => (
  <div
    key={`${trialName}-${sectionIndex}`}
    style={{ ...styling }}
  >
    <h4>
      Trial Name:
      {trialName}
      {section && section.headline && `, Sektion: ${section.headline}`}
    </h4>
    {section.questions.map((question) => {
      const answer = answers ? answers.questions[question.question.uuid] : undefined;
      return (
        <MainQuestionPrint
          key={question.id}
          question={question}
          numCases={section.numCases}
          answer={answer}
        />
      );
    })}
    {section.contextQuestions
      && section.contextQuestions.map((question) => {
        const answer = answers ? answers.context[question.question.uuid] : undefined;
        return (
          <ContextQuestionPrint
            key={question.id}
            question={{ ...question }}
            answers={answer}
          />
        );
      })}
  </div>
);

export default SectionSurveyPrint;

SectionSurveyPrint.propTypes = {
  section: PropTypes.shape({
    numCases: PropTypes.number,
    headline: PropTypes.string.isRequired,
    questions: PropTypes.object.isRequired,
    contextQuestions: PropTypes.object.isRequired,
  }).isRequired,
  trialName: PropTypes.string.isRequired,
  sectionIndex: PropTypes.number.isRequired,
  answers: PropTypes.object.isRequired,
};
